import { EEvidenceEvent } from "dto/EEvidenceEvent";

export const evidenceEventToStatus = (
  event: EEvidenceEvent,
  IsIncoming: boolean
) => {
  switch (event) {
    case EEvidenceEvent.SubmissionAcceptance:
      return "Nadana";
    case EEvidenceEvent.SubmissionRejection:
      return "Odrzucona";
    case EEvidenceEvent.RelayAcceptance:
      return "Przekazana";
    case EEvidenceEvent.RelayRejection:
      return "Odrzucona";
    case EEvidenceEvent.RelayFailure:
      return "Błąd";
    case EEvidenceEvent.NotificationForAcceptance:
      return "Awizowana";
    case EEvidenceEvent.NotificationForAcceptanceFailure:
      return "Błąd";
    case EEvidenceEvent.ConsignmentAcceptance:
      return "Zaakceptowana";
    case EEvidenceEvent.ConsignmentRejection:
      return "Odrzucona";
    case EEvidenceEvent.AcceptanceRejectionExpiry:
      return "Nieodebrana w terminie";
    case EEvidenceEvent.ContentConsignment:
      return "Przekazana";
    case EEvidenceEvent.ContentConsignmentFailure:
      return "";
    case EEvidenceEvent.ConsignmentNotification:
      return "";
    case EEvidenceEvent.ConsignmentNotificationFailure:
      return "";
    case EEvidenceEvent.ContentHandover:
      return "Doręczona";
    case EEvidenceEvent.ContentHandoverFailure:
      return "Błąd doręczenia";
    case EEvidenceEvent.RelayToNonERDS:
      return "Błąd";
    case EEvidenceEvent.RelayToNonERDSFailure:
      return "Błąd";
    case EEvidenceEvent.ReceivedFromNonERDS:
      return "Błąd";
  }
  return "Oczekuje na wysłanie";
};
